module.exports = __webpack_public_path__ + "img/box.88d31b91.svg";